<template>
  <div>
    <el-dialog top="5vh"
               title="修改课时费"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               :close-on-click-modal="false"
               width="600px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="100px"
               size="small">
        <el-form-item label="课时费："
                      prop="final_real_lesson_hour_amount">
          <el-input placeholder="请输入课时费"
                    v-model="dataForm.final_real_lesson_hour_amount"
                    class="input-with-select"
                    oninput="value=value.replace(/[^0-9.]/g,'')">
            <span slot="append">元/小时</span>
          </el-input>
          <div class="gray">
            其中包含：
            <div style="display:flex;justify-content: space-between;width:80%">
              <div style="position: relative;width:50%">
                <el-input v-model="dataForm.salary_profit_fix_amount"
                          style="marginRight:10px"
                          placeholder=""
                          oninput="value=value.replace(/[^0-9.]/g,'')"
                          @blur="basInput">

                  <template slot="prepend">基础课时费</template>
                </el-input>
                <span style=" position: absolute;top:1px;right:2px;fontSize:12px;">元/小时</span>
              </div>
              <div style="position: relative;width:45%">
                <el-input v-model="dataForm.bonus_profit_fix_amount"
                          style="marginRight:10px"
                          placeholder=""
                          @blur="signInput"
                          oninput="value=value.replace(/[^0-9.]/g,'')">
                  <template slot="prepend">结课奖励</template>
                </el-input>
                <span style=" position: absolute;top:1px;right:2px;fontSize:12px;">元/小时</span>
              </div>

            </div>

          </div>
        </el-form-item>
      </el-form>
      <div class="tips">
        此课时费修改只对本次有效，想要修改其他课时费请前往班
        级中点击“授课老师”进行修改
      </div>
      <div class="footer">
        <el-button @click="emitClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { lessonLogListEdit } from '@/request/api'
export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
        bonus_profit_fix_amount: null,
        salary_profit_fix_amount: null,
      },
      rules: {
        teacher_grade_lesson_hour_amount: [
          { required: true, message: '请输入课时费', trigger: 'blur' },
          {
            pattern: /^(\d+|\d+\.\d{1,2})$/,
            message: '输入最多两位小数的数字',
          },
        ],
      },
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    list(val) {
      console.log(val)
    },
  },
  methods: {
    basInput(e) {
      this.dataForm.bonus_profit_fix_amount =
        Math.round(
          (this.dataForm.final_real_lesson_hour_amount -
            this.dataForm.salary_profit_fix_amount) *
            100
        ) / 100
      console.log(
        'this.dataForm.bonus_profit_fix_amount',
        this.dataForm.bonus_profit_fix_amount
      )
    },
    signInput(e) {
      this.dataForm.salary_profit_fix_amount =
        Math.round(
          (this.dataForm.final_real_lesson_hour_amount -
            this.dataForm.bonus_profit_fix_amount) *
            100
        ) / 100
    },
    emitClose() {
      this.$emit('close')
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          lessonLogListEdit({
            rows: this.list.map((v) => {
              return {
                id: v.id,
                final_real_lesson_hour_amount:
                  this.dataForm.final_real_lesson_hour_amount,
                // salary_split_type: 2,
                // salary_profit_fix_amount:
                //   this.dataForm.salary_profit_fix_amount,
                // bonus_profit_fix_amount: this.dataForm.bonus_profit_fix_amount,
              }
            }),
          }).then((response) => {
            let res = response.data
            if (res.code == 0) {
              this.$message.success('修改成功')
              this.$emit('submit', {
                ids: this.list.map((v) => {
                  return v.id
                }),
                final_real_lesson_hour_amount:
                  this.dataForm.final_real_lesson_hour_amount,
                final_real_salary_profit_fix_amount:
                  this.dataForm.salary_profit_fix_amount,
                final_real_bonus_profit_fix_amount:
                  this.dataForm.bonus_profit_fix_amount,
              })
              this.emitClose()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.tips {
  font-size: 14px;
  font-weight: 400;
  color: #c0c4cc;
  line-height: 22px;
}
</style>